import React from 'react';
import { colors } from '../styles/colors';

interface SlotDisplayProps {
  value: number;
  label?: string;
}

const SlotDisplay: React.FC<SlotDisplayProps> = ({ value, label }) => {
  const getDisplayText = () => {
    if (value === -1) return 'Não incluído';
    if (value === 0) return 'Ilimitado';
    return `${value} ${value === 1 ? 'slot' : 'slots'}`;
  };

  const getColor = () => {
    if (value === -1) return colors.error;
    if (value === 0) return colors.success;
    return colors.primary;
  };

  const getBadgeStyle = () => ({
    ...styles.badge,
    backgroundColor: getColor()
  });

  return (
    <span style={getBadgeStyle()}>
      {getDisplayText()}
    </span>
  );
};

const styles = {
  badge: {
    color: 'white',
    padding: '0.2rem 0.6rem',
    borderRadius: '4px',
    fontSize: '0.8rem',
    fontWeight: 'bold' as const,
    display: 'inline-block',
  },
};

export default SlotDisplay;